import React, { type FunctionComponent, useState } from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  Text,
} from '@retailer-platform/shared-components'
import { type QualityAuditWorkflowColumnConfig } from '../../../types/qualityAuditWorkflows.types.ts'
import { useDomainMessages } from '../../../utils/domain/intl.ts'
import { PropertyContainer } from '../../shared-styled-components/SharedStyledComponents.tsx'
import {
  Property,
  PropertySection,
  PropertyTitle,
  TextInput,
} from '../../../utils/common.styles.tsx'

interface Props {
  columnConfig: QualityAuditWorkflowColumnConfig
  onClose: () => void
  onSave: (columnConfig: QualityAuditWorkflowColumnConfig) => void
}

export const QualityAuditWorkflowConfigColumnFeatureModal: FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ onClose, onSave, columnConfig }) => {
  const [features, setFeatures] = useState<string | undefined>(columnConfig?.features)

  const i18n = useDomainMessages({
    save: 'catalogAdminDomain.qualityAuditWorkflows.configs.modal.save',
    close: 'catalogAdminDomain.qualityAuditWorkflows.configs.modal.close',
    features: 'catalogAdminDomain.qualityAuditWorkflows.configs.modal.features',
    featureDetails: 'catalogAdminDomain.qualityAuditWorkflows.configs.modal.features.details',
  })

  return (
    <Modal maxWidth={'50%'} maxHeight={'100%'} isOpen={true} hideCloseButton={true}>
      <ModalContainer>
        <ModalHeader>{i18n.features}</ModalHeader>
        <ModalBody>
          <PropertyContainer style={{ flexDirection: 'column' }}>
            <PropertySection style={{ flexDirection: 'row' }}>
              <Property style={{ flex: 1 }}>
                <PropertyTitle>{i18n.features}</PropertyTitle>
                <Text size="small" css={{ flex: 1 }}>
                  {i18n.featureDetails}
                </Text>
                <TextInput
                  style={{ width: '100%', height: '200px' }}
                  error={false}
                  onChange={event => setFeatures(event.target.value)}
                  value={features ?? ''}
                />
              </Property>
            </PropertySection>
          </PropertyContainer>
        </ModalBody>
        <ModalFooter>
          <Button variant={'secondary'} onClick={() => onClose()}>
            {i18n.close}
          </Button>
          <Button
            variant={'primary'}
            onClick={() => {
              onSave({
                ...columnConfig,
                features,
              })
            }}
          >
            {i18n.save}
          </Button>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  )
}
